"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalculateAgeAt = exports.CalculateAge = exports.Concept = exports.ConceptRef = exports.ConceptDef = exports.Code = exports.CodeRef = exports.CodeDef = exports.CodeSystemDef = exports.InValueSet = exports.AnyInValueSet = exports.ValueSetRef = exports.ValueSetDef = void 0;
var expression_1 = require("./expression");
var dt = __importStar(require("../datatypes/datatypes"));
var builder_1 = require("./builder");
var ValueSetDef = /** @class */ (function (_super) {
    __extends(ValueSetDef, _super);
    function ValueSetDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.id = json.id;
        _this.version = json.version;
        return _this;
    }
    //todo: code systems and versions
    ValueSetDef.prototype.exec = function (ctx) {
        var valueset = ctx.codeService.findValueSet(this.id, this.version) || new dt.ValueSet(this.id, this.version);
        ctx.rootContext().set(this.name, valueset);
        return valueset;
    };
    return ValueSetDef;
}(expression_1.Expression));
exports.ValueSetDef = ValueSetDef;
var ValueSetRef = /** @class */ (function (_super) {
    __extends(ValueSetRef, _super);
    function ValueSetRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.libraryName = json.libraryName;
        return _this;
    }
    ValueSetRef.prototype.exec = function (ctx) {
        // TODO: This calls the code service every time-- should be optimized
        var valueset = ctx.getValueSet(this.name, this.libraryName);
        if (valueset instanceof expression_1.Expression) {
            valueset = valueset.execute(ctx);
        }
        return valueset;
    };
    return ValueSetRef;
}(expression_1.Expression));
exports.ValueSetRef = ValueSetRef;
var AnyInValueSet = /** @class */ (function (_super) {
    __extends(AnyInValueSet, _super);
    function AnyInValueSet(json) {
        var _this = _super.call(this, json) || this;
        _this.codes = (0, builder_1.build)(json.codes);
        _this.valueset = new ValueSetRef(json.valueset);
        return _this;
    }
    AnyInValueSet.prototype.exec = function (ctx) {
        var valueset = this.valueset.execute(ctx);
        // If the value set reference cannot be resolved, a run-time error is thrown.
        if (valueset == null || !valueset.isValueSet) {
            throw new Error('ValueSet must be provided to InValueSet function');
        }
        var codes = this.codes.exec(ctx);
        return codes != null && codes.some(function (code) { return valueset.hasMatch(code); });
    };
    return AnyInValueSet;
}(expression_1.Expression));
exports.AnyInValueSet = AnyInValueSet;
var InValueSet = /** @class */ (function (_super) {
    __extends(InValueSet, _super);
    function InValueSet(json) {
        var _this = _super.call(this, json) || this;
        _this.code = (0, builder_1.build)(json.code);
        _this.valueset = new ValueSetRef(json.valueset);
        return _this;
    }
    InValueSet.prototype.exec = function (ctx) {
        // If the code argument is null, the result is false
        if (this.code == null) {
            return false;
        }
        if (this.valueset == null) {
            throw new Error('ValueSet must be provided to InValueSet function');
        }
        var code = this.code.execute(ctx);
        // spec indicates to return false if code is null, throw error if value set cannot be resolved
        if (code == null) {
            return false;
        }
        var valueset = this.valueset.execute(ctx);
        if (valueset == null || !valueset.isValueSet) {
            throw new Error('ValueSet must be provided to InValueSet function');
        }
        // If there is a code and valueset return whether or not the valueset has the code
        return valueset.hasMatch(code);
    };
    return InValueSet;
}(expression_1.Expression));
exports.InValueSet = InValueSet;
var CodeSystemDef = /** @class */ (function (_super) {
    __extends(CodeSystemDef, _super);
    function CodeSystemDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.id = json.id;
        _this.version = json.version;
        return _this;
    }
    CodeSystemDef.prototype.exec = function (_ctx) {
        return new dt.CodeSystem(this.id, this.version);
    };
    return CodeSystemDef;
}(expression_1.Expression));
exports.CodeSystemDef = CodeSystemDef;
var CodeDef = /** @class */ (function (_super) {
    __extends(CodeDef, _super);
    function CodeDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.id = json.id;
        _this.systemName = json.codeSystem.name;
        _this.display = json.display;
        return _this;
    }
    CodeDef.prototype.exec = function (ctx) {
        var system = ctx.getCodeSystem(this.systemName).execute(ctx);
        return new dt.Code(this.id, system.id, system.version, this.display);
    };
    return CodeDef;
}(expression_1.Expression));
exports.CodeDef = CodeDef;
var CodeRef = /** @class */ (function (_super) {
    __extends(CodeRef, _super);
    function CodeRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.library = json.libraryName;
        return _this;
    }
    CodeRef.prototype.exec = function (ctx) {
        ctx = this.library ? ctx.getLibraryContext(this.library) : ctx;
        var codeDef = ctx.getCode(this.name);
        return codeDef ? codeDef.execute(ctx) : undefined;
    };
    return CodeRef;
}(expression_1.Expression));
exports.CodeRef = CodeRef;
var Code = /** @class */ (function (_super) {
    __extends(Code, _super);
    function Code(json) {
        var _this = _super.call(this, json) || this;
        _this.code = json.code;
        _this.systemName = json.system.name;
        _this.version = json.version;
        _this.display = json.display;
        return _this;
    }
    Object.defineProperty(Code.prototype, "isCode", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Code.prototype.exec = function (ctx) {
        var system = ctx.getCodeSystem(this.systemName) || {};
        return new dt.Code(this.code, system.id, this.version, this.display);
    };
    return Code;
}(expression_1.Expression));
exports.Code = Code;
var ConceptDef = /** @class */ (function (_super) {
    __extends(ConceptDef, _super);
    function ConceptDef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        _this.display = json.display;
        _this.codes = json.code;
        return _this;
    }
    ConceptDef.prototype.exec = function (ctx) {
        var codes = this.codes.map(function (code) {
            var codeDef = ctx.getCode(code.name);
            return codeDef ? codeDef.execute(ctx) : undefined;
        });
        return new dt.Concept(codes, this.display);
    };
    return ConceptDef;
}(expression_1.Expression));
exports.ConceptDef = ConceptDef;
var ConceptRef = /** @class */ (function (_super) {
    __extends(ConceptRef, _super);
    function ConceptRef(json) {
        var _this = _super.call(this, json) || this;
        _this.name = json.name;
        return _this;
    }
    ConceptRef.prototype.exec = function (ctx) {
        var conceptDef = ctx.getConcept(this.name);
        return conceptDef ? conceptDef.execute(ctx) : undefined;
    };
    return ConceptRef;
}(expression_1.Expression));
exports.ConceptRef = ConceptRef;
var Concept = /** @class */ (function (_super) {
    __extends(Concept, _super);
    function Concept(json) {
        var _this = _super.call(this, json) || this;
        _this.codes = json.code;
        _this.display = json.display;
        return _this;
    }
    Object.defineProperty(Concept.prototype, "isConcept", {
        // Define a simple getter to allow type-checking of this class without instanceof
        // and in a way that survives minification (as opposed to checking constructor.name)
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Concept.prototype.toCode = function (ctx, code) {
        var system = ctx.getCodeSystem(code.system.name) || {};
        return new dt.Code(code.code, system.id, code.version, code.display);
    };
    Concept.prototype.exec = function (ctx) {
        var _this = this;
        var codes = this.codes.map(function (code) { return _this.toCode(ctx, code); });
        return new dt.Concept(codes, this.display);
    };
    return Concept;
}(expression_1.Expression));
exports.Concept = Concept;
var CalculateAge = /** @class */ (function (_super) {
    __extends(CalculateAge, _super);
    function CalculateAge(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    CalculateAge.prototype.exec = function (ctx) {
        var date1 = this.execArgs(ctx);
        var date2 = dt.DateTime.fromJSDate(ctx.getExecutionDateTime());
        var result = date1 != null ? date1.durationBetween(date2, this.precision.toLowerCase()) : undefined;
        if (result != null && result.isPoint()) {
            return result.low;
        }
        else {
            return result;
        }
    };
    return CalculateAge;
}(expression_1.Expression));
exports.CalculateAge = CalculateAge;
var CalculateAgeAt = /** @class */ (function (_super) {
    __extends(CalculateAgeAt, _super);
    function CalculateAgeAt(json) {
        var _this = _super.call(this, json) || this;
        _this.precision = json.precision;
        return _this;
    }
    CalculateAgeAt.prototype.exec = function (ctx) {
        // eslint-disable-next-line prefer-const
        var _a = this.execArgs(ctx), date1 = _a[0], date2 = _a[1];
        if (date1 != null && date2 != null) {
            // date1 is the birthdate, convert it to date if date2 is a date (to support ignoring time)
            if (date2.isDate && date1.isDateTime) {
                date1 = date1.getDate();
            }
            var result = date1.durationBetween(date2, this.precision.toLowerCase());
            if (result != null && result.isPoint()) {
                return result.low;
            }
            else {
                return result;
            }
        }
        return null;
    };
    return CalculateAgeAt;
}(expression_1.Expression));
exports.CalculateAgeAt = CalculateAgeAt;
//# sourceMappingURL=clinical.js.map